export default __webpack_public_path__ + "assets/images/26d5002647f1c8b7e910922beb06c4f7.jpg";